export default import.meta.ROLLUP_FILE_URL_RGei5JJ4zpyRRcYRqD5PPw;